import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Avatar from "../../Avatar/Avatar";
import QRCodeModal from "../../QRCodeModal/QRCodeModal";
import {
  showAlert,
  showLoading,
  apiRequest,
  PLAYER_URL_PREFIX,
  formatPlayerNo,
} from "../../../utils";
import { Confirm } from "../../../components/confirm/confirm";
import { TEAM_COLOR_NAME, TEAM_COLORS } from "../../../constants";

import ss from "./TeamInfo.module.css";
import classNames from "classnames";

export const TeamInfo = () => {
  const session_uuid = useSelector((state) => state.gameSession.session_uuid);
  const [teamList, setTeamList] = useState(null);
  const [showTeamPlayers, setShowTeamPlayers] = useState(false);
  const [currentTeamPlayers, setCurrentTeamPlayers] = useState([]);
  const [currentTeam, setCurrentTeam] = useState({});
  // 队伍中心信息
  const [teamCenterInfo, setTeamCenterInfo] = useState({});

  const getTeamList = () => {
    const loading = showLoading("加载中");
    apiRequest("/get_team_list", "GET", { session_uuid })
      .then((res) => {
        if (res.code === 0) {
          setTeamList(res.teams);
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message))
      .finally(() => {
        loading.hide();
      });
  };

  const getTeamCenterInfo = async (tid) => {
    // const loading = showLoading("加载中");
    apiRequest("/team_center_info", "GET", { tid }).then((res) => {
      if (res.code === 0) setTeamCenterInfo(res.data);
      else showAlert(res.msg);
    });
    // .finally(() => loading.hide());
  };

  const getTeamPlayers = (tid) => {
    apiRequest("/get_team_players", "GET", { tid })
      .then((res) => {
        if (res.code === 0) {
          setCurrentTeamPlayers(res.players);
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message));
  };

  // 获取场次信息
  useEffect(() => {
    getTeamList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session_uuid]);

  if (!teamList) return null;

  // 计算当前能量值的排名
  const getTeamRank = (energy) => {
    const sortedTeams = [...teamList]
      .map((team) => team.energy)
      .sort((a, b) => b - a);
    return sortedTeams.indexOf(energy) + 1;
  };

  const closeModal = () => {
    setShowTeamPlayers(false);
  };

  return (
    <div className={ss.container}>
      <div className={ss.title}>队伍信息</div>
      <div className={ss.teamList}>
        {teamList.map((team) => (
          <div className={ss.teamItem} key={team.id}>
            <div
              className={ss.teamItemAvatar}
              onClick={() => {
                getTeamCenterInfo(team.uuid);
                getTeamPlayers(team.uuid);
                setCurrentTeam(team);
                setShowTeamPlayers(true);
              }}
            >
              <Avatar
                style={{
                  margin: "0rem",
                }}
                num={team.color} // 索引从0开始，但编号从1开始
                width={1.67}
              />
              <div className={ss.teamRank}>{getTeamRank(team.energy)}</div>
            </div>
            <div
              className={classNames(ss.teamItemPlayers, ss.short)}
              onClick={() => {
                // 展示队伍加入二维码
                QRCodeModal.show({
                  type: "join",
                  url: `${PLAYER_URL_PREFIX}/join?tid=${team.uuid}`,
                  ext: { teamColor: team.color, teamName: team.name },
                  onClose: () => {
                    QRCodeModal.hide();
                  },
                });
              }}
            >
              {team.number_of_players}人
            </div>
            <div className={classNames(ss.teamItemLevel, ss.short)}>
              {team.level}级
            </div>
            <div className={ss.teamItemLevel}>能量值：{team.energy}</div>
            <div
              className={ss.teamItemBtn}
              onClick={() => {
                Confirm.show(
                  `请确认是否对【${
                    TEAM_COLOR_NAME[team.color]
                  }】队进行犯规惩罚`,
                  () => {
                    const loading = showLoading("加载中");
                    apiRequest("/punish_team", "GET", { tid: team.uuid })
                      .then((res) => {
                        if (res.code === 0) {
                          showAlert(
                            `【${TEAM_COLOR_NAME[team.color]}】队已惩罚`
                          );
                          getTeamList();
                        } else showAlert(res.msg);
                      })
                      .catch((err) =>
                        showAlert("请求失败，请稍后重试", err.message)
                      )
                      .finally(() => {
                        loading.hide();
                      });
                  }
                );
              }}
            >
              犯规惩罚
            </div>
          </div>
        ))}
      </div>
      <div className={classNames(ss.maskBg, showTeamPlayers && ss.show)}>
        <div className={classNames(ss.modal, ss.join)}>
          <div className={ss.teamInfo}>
            {currentTeam?.color && (
              <>
                <Avatar
                  num={currentTeam.color}
                  width={2.34}
                  style={{ margin: "0 auto" }}
                />
                <div
                  className={ss.teamName}
                  style={{ color: TEAM_COLORS[currentTeam.color] }}
                >
                  【{currentTeam.name}】
                </div>
                <div className={ss.teamCenterInfo}>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>任务成功</div>
                    <div className={ss.teamCenterInfoValue}>
                      {teamCenterInfo.tasks_success}/次
                    </div>
                  </div>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>抢夺成功</div>
                    <div className={ss.teamCenterInfoValue}>
                      {teamCenterInfo.rob_success}/次
                    </div>
                  </div>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>被抢夺</div>
                    <div className={ss.teamCenterInfoValue}>
                      {teamCenterInfo.be_robbed_success}/次
                    </div>
                  </div>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>占领成功</div>
                    <div className={ss.teamCenterInfoValue}>
                      {teamCenterInfo.occupy_success}/次
                    </div>
                  </div>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>能量站收益</div>
                    <div className={ss.teamCenterInfoValue}>
                      {teamCenterInfo.occupy_total_reward}/点
                    </div>
                  </div>
                  <div className={ss.teamCenterInfoItem}>
                    <div className={ss.teamCenterInfoLable}>判定失败</div>
                    <div
                      className={classNames(ss.teamCenterInfoValue, ss.failed)}
                    >
                      {teamCenterInfo.failed_energy}/点
                    </div>
                  </div>
                </div>
                <div className={ss.playerList}>
                  <div className={ss.listContainer}>
                    {currentTeamPlayers.map((player) => (
                      <div className={ss.playerItem} key={player.id}>
                        {formatPlayerNo(player.player_no)}号【{player.password}
                        】
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className={ss.close} onClick={closeModal}></div>
      </div>
    </div>
  );
};
